module.exports = __webpack_public_path__ + "static/media/logos_squares_CoOrg_HKSTP.fb780456.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_CoOrg_HKSTP.png
// module id = 38
// module chunks = 0